import React, { useMemo } from "react";
import { Box } from "@mui/material";
import { attrTableStrColumnsObj } from "components/PimDashboard/data";
import { inputTypes, arrType } from "data/globalData";
import { getColDefaultValue } from "components/PimDashboard/data";
import RenderInputField from "../RenderInputField/RenderInputField";

export const removeDropdownOptionsBasedonDependency = (column, data, options, allColumns, attrValAssocObj) => {
	if (
		(column[attrTableStrColumnsObj.input_type.key] === inputTypes.SELECT.key ||
			column[attrTableStrColumnsObj.input_type.key] === inputTypes.MULTIPLE_SELECT.key) &&
		options
	) {
		let list = [];
		let dependentCols = allColumns?.filter((row) => column?.dependency?.[row.key] === true);

		if (dependentCols?.length) {
			column[attrValAssocObj]?.forEach((attrVal) => {
				let push = true;
				dependentCols.forEach((col) => {
					const dataValue = data?.[col.key];
					const hasValue = Array.isArray(dataValue) ? dataValue.length > 0 : (dataValue && dataValue !== getColDefaultValue(col));
					
					if (hasValue) {
						const valuesToCheck = Array.isArray(dataValue) ? dataValue : [dataValue];
						const hasMatch = valuesToCheck.some(val => attrVal?.dependency?.[col.key]?.includes(val));
						if (!hasMatch) {
							push = false;
						}
					}
				});
				if (push) list.push(attrVal);
			});
		} else list = column[attrValAssocObj];

		return {
			type: arrType,
			list: list.map((val) => ({ name: val?.value, key: val?.value })),
		};
	} else return {};
};

const RenderAttributeInputs = ({
	columns,
	setData,
	data,
	width,
	inputWidth,
	errObj = {},
	setErrorObj = () => {},
	selectOptObjOptName,
}) => {
	return (
		<Box display="flex" width={width ? width : "100%"} flexWrap="wrap" p={1} columnGap="1%" alignItems="flex-start" rowGap="3px">
			{columns?.map((column) => (
				<InputItem
					key={column.key}
					column={column}
					data={data}
					setData={setData}
					errObj={errObj}
					setErrorObj={setErrorObj}
					allColumns={columns}
					selectOptObjName={selectOptObjOptName}
					inputWidth={inputWidth}
				/>
			))}
		</Box>
	);
};

export default RenderAttributeInputs;

const InputItem = React.memo(({ column, data, setData, errObj, setErrorObj, selectOptObjName, allColumns = [], inputWidth }) => {
	const options = useMemo(
		() => removeDropdownOptionsBasedonDependency(column, data, column?.[selectOptObjName], allColumns, selectOptObjName),
		[column, data, allColumns, selectOptObjName]
	);

	return (
		<RenderInputField
			column={{ ...column, [selectOptObjName]: options }}
			data={data}
			setData={setData}
			selectOptObjName={selectOptObjName}
			width={inputWidth ?? "24%"}
			longWidth="49%"
			error={!!errObj?.[column.key]}
			setError={setErrorObj}
		/>
	);
});
